<template>
  <div class="popup-wrapper" @click.self="group1.close">
    <div class="popup-container md center">
      <div class="button close">
        <span role="button" class="btn" @click="group1.close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">並び順の設定</span>
        </div>
        <div class="popup-content">
          <div class="formparts radio">
            <input v-model="group1.list_order" type="radio" id="order_settings_01" value="score">
            <label for="order_settings_01" role="button">関連度順</label>
          </div>
          <div class="formparts radio">
            <input v-model="group1.list_order" type="radio" id="order_settings_02" value="book">
            <label for="order_settings_02" role="button">書籍順</label>
          </div>
          <div class="button mt32">
            <button class="btn" type="button" name="button"
              @click="group1.submit"
            >設定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import * as logicQASearchOrderSetting from '@/logic/qa/QASearchOrderSetting'

export default defineComponent({
  setup (props, context) {

    const group1 = logicQASearchOrderSetting.getGroup(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
